import { render, staticRenderFns } from "./ProjectPOAEvMiddle.vue?vue&type=template&id=04c904d0"
import script from "./ProjectPOAEvMiddle.vue?vue&type=script&lang=js"
export * from "./ProjectPOAEvMiddle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports